import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
// @ts-ignore
import { defaultTrans } from 'ipsos-filters-panel/dist-lib/filters_bar.es'
import { module } from 'constant'
// @ts-ignore
import filter from './filter.vue'

const { filterVue } = module.filter

const defaultLocale = 'en'
export const i18n = createI18n({
	locale: defaultLocale,
	fallbackLocale: defaultLocale,
	missingWarn: false,
	legacy: false,
	globalInjection: true,
	messages: {
		en: defaultTrans,
	},
})

export const FilterVue = () => {
	const init = (isAjax: boolean) => {
		if (isAjax) {
			return
		}

		const app = createApp(filter)
		app.use(i18n)
		app.config.performance = true
		app.mount(filterVue.instance)
	}

	return {
		init,
		i18n,
	}
}
